import { render } from "./SupportTicketSidebar.vue?vue&type=template&id=009dd665&scoped=true"
import script from "./SupportTicketSidebar.vue?vue&type=script&lang=js"
export * from "./SupportTicketSidebar.vue?vue&type=script&lang=js"

import "./SupportTicketSidebar.vue?vue&type=style&index=0&id=009dd665&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009dd665"]])

export default __exports__